import { $ } from "./imports";

    // Cambia texto y muestra filtros en mobile
    function changeTxtFiltrosMobile(){
        let $btnFilterMobile = $('.filterbar__collapse-btn');
        let $btnTxtCWrapper = $btnFilterMobile.find('.button__txt');
        let firstTxt = $btnTxtCWrapper.text();

        $btnFilterMobile.on('click', function(){
            if( $btnFilterMobile.hasClass('collapsed') ){
                $btnTxtCWrapper.text(firstTxt);
            }else{
                $btnTxtCWrapper.text('Ocultar filtros');
            }
        });

    }

    // Función para crear un tag de filtro aplicado
    function createTag(tagText, selectId) {
        const tag = document.createElement('div');
        tag.classList.add('filter-item');
        tag.innerHTML = `${tagText}<span class="filter-item__action"><img src="/themes/custom/protactics/dist/assets/images/icons/close-white.svg" alt="Icono borrar"></span>`;

        // Agregar un listener al botón de eliminar para cambiar el valor del select
        tag.querySelector('.filter-item__action').addEventListener('click', () => {
            const select = document.getElementById(selectId);
            select.value = 'All';
            tag.parentNode.removeChild(tag); // Eliminar el tag del DOM
            // Crear clave session storage para que mantenga otros tags
            sessionStorage.setItem('applyButtonClicked', 'true');
            document.querySelector('.filterbar__form form .form-actions .form-submit').click();
        });

        return tag;
    }

    // Función para generar tags automáticamente
    function generateTagsAutomatically(selectElements) {
        // Obtener contenedor de tags
        const filterTagsContainer = document.querySelector('.aplied-filters__tags .aplied-filters__list');

        // Limpiar los tags existentes en el contenedor
        filterTagsContainer.innerHTML = '';

        selectElements.forEach((select) => {
            if (select.getAttribute('name') !== 'sort_by' && select.getAttribute('name') !== 'sort_order') {
                const selectedOption = select.options[select.selectedIndex];
                
                if (selectedOption.value !== 'All') {
                    const tagText = selectedOption.textContent;
                    const selectId = select.getAttribute('id');
                    const tag = createTag(tagText, selectId);
                    
                    // Agregar el tag al contenedor de tags
                    filterTagsContainer.appendChild(tag);
                }
            }
        });
    }

    // Función para manejar el evento change de los select
    function handleSelectChange(event) {
        const select = event.target;
        const selectedOption = select.options[select.selectedIndex];

        // Obtener contenedor de tags
        const filterTagsContainer = document.querySelector('.aplied-filters__tags .aplied-filters__list');
        
        if (selectedOption.value !== 'All') {
            const tagText = selectedOption.textContent;
            const selectId = select.getAttribute('id');
            const tag = createTag(tagText, selectId);

            // Agregar el tag al contenedor de tags
            filterTagsContainer.appendChild(tag);
        }
    }

    function changeSelects(selectElements){
        // Agregar el evento change a los select (excepto los selects con name "sort_by" y "sort_order")
        selectElements.forEach((select) => {
            if (select.getAttribute('name') !== 'sort_by' && select.getAttribute('name') !== 'sort_order') {
                select.addEventListener('change', () => {
                    select.addEventListener('change', handleSelectChange);
                });
            }
        });
    }

    function clearFilters(){
        // Obtener boton limpiar filtros
        let $clearFilterButton = $('body').find('.aplied-filters__clear');

        // Si no hay tags ocultamos
        if($('.filter-item').length > 0){
            $clearFilterButton.removeClass('d-none');
        }else{
            $clearFilterButton.addClass('d-none');
        }

        // Añadimos evento click
        $clearFilterButton.on('click', ()=>{
            // Obtenemos boton de limpiar filtros real en la barra de filtros(donde estan los selects)
            // $('.filterbar__form form .form-actions .form-submit[value="Limpiar filtros"]').trigger('click');
            $('.filterbar__form form .form-actions .form-submit[data-drupal-selector="edit-reset"]').trigger('click');
        });
    }

    // Filter Order by
    // Para clonar el select de "Order By"
    function filterOrderBy(){
        // Obtener el elemento original y su select
        const originalElement = document.querySelector('.filterbar__form .form-item-sort-order');
        const originalSelect = originalElement.querySelector('select');

        // Verificar si el clon ya existe en el DOM
        if (!document.querySelector('#edit-sort-order-clone')) {
            // Crear un clon del elemento original
            const clonedElement = originalElement.cloneNode(true);

            // Cambiar los atributos del clon
            const clonedSelect = clonedElement.querySelector('select');
            clonedSelect.id = 'edit-sort-order-clone'; // Cambiar el ID
            clonedSelect.name = 'sort_order_clone'; // Cambiar el name
            clonedElement.querySelector('label').setAttribute('for', 'edit-sort-order-clone'); // Cambiar el for del label
            
            // Insertar el clon en otro lugar del DOM
            const clonedContainer = document.querySelector('.aplied-filters__right .aplied-filters__order');
            clonedContainer.appendChild(clonedElement);
            
            // Agregar el evento change al select clon
            clonedSelect.addEventListener('change', (event)=>{
                syncSelects(event);
                // Crear clave session storage para que mantenga otros tags
                sessionStorage.setItem('applyButtonClicked', 'true');
                document.querySelector('.filterbar__form form .form-actions .form-submit').click();
            });            
            
            // Sincronizar el select clon con el original
            clonedSelect.value = originalSelect.value;
        }

        
        // Función para sincronizar los selects
        function syncSelects(event) {
            const selectedValue = event.target.value;
            originalSelect.value = selectedValue;
        }

        // Agregar el evento change al select original
        originalSelect.addEventListener('change', syncSelects);

    }

    function emptyResultsStyles(){
        // verifica si existe el siguiente elemento, y añade clase para que no se solape debajo del header
        if( $('.aplied-filters__empty').length > 0 ){
            $('.aplied-filters').addClass('header-space')
        }else{
            if( $('.aplied-filters').hasClass('header-space') ){
                $('.aplied-filters').removeClass('header-space');
            }
        }
    }

    function noBannerMargin(){
        // Si no existe la sección de banner agrega clase con nuevos margenes
        if( $('body.path-productos .banner__wrapper.banner--small').length <= 0 ){
            $('.filterbar').addClass('no-banner');
        }
    }

    export function createTagsFilters(){
        let $filterbar = $('.filterbar');

        // Si existe la barra de filtros ejecuta sus funciones
        if($filterbar.length > 0){

            // Obtener los select
            let selectElements = document.querySelectorAll('.filterbar__form form .form--inline .form-item select');            
    
            // Crear tags
            generateTagsAutomatically(selectElements);

            // Escuchar cambios selects
            // changeSelects(selectElements);
        }
    }

    export function otherFilterFuntions(){
        let $filterbar = $('.filterbar');

        // Si existe la barra de filtros ejecuta sus funciones
        if($filterbar.length > 0){

            changeTxtFiltrosMobile();
    
            clearFilters();
    
            filterOrderBy();
            
            // Establece una entrada en el sessionStorage para indicar que se hizo clic en el botón "Aplicar"
            $('body').on('click', '.filterbar__form form .form-actions .button--primary.inputreplace', () => {
                sessionStorage.setItem('applyButtonClicked', 'true');
            });

            emptyResultsStyles();

            noBannerMargin();
    
        }
    }
    
    export function allFilterbarFunctions(){
        createTagsFilters();
        otherFilterFuntions();
    }